import { ImperialLengthUnit, LengthUnit, MetricLengthUnit } from '@app/shared/units/length/length-unit.enum';

// relative to 1 meter
export const lengthFactors: Record<LengthUnit, number> = {
  [MetricLengthUnit.Millimeter]: 0.001,
  [MetricLengthUnit.Centimeter]: 0.01,
  [MetricLengthUnit.Meter]: 1,
  [MetricLengthUnit.Kilometer]: 1000,

  [ImperialLengthUnit.Inch]: 0.0254,
  [ImperialLengthUnit.Foot]: 0.3048,
  [ImperialLengthUnit.Yard]: 0.9144,
  [ImperialLengthUnit.Mile]: 1609.34,
};
